import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ArtistAttribution } from '../ArtistAttribution';
import { FooterImage } from './FooterImage';

import { ARTIST_SOCIAL_LINKS_PROPTYPE } from '../../../../constants';

import './cityBrowseFooter.scss';

export class CityBrowseFooter extends React.PureComponent {
    static propTypes = {
        footerImage: PropTypes.string,
        footerSmallImage: PropTypes.string,
        artistImage: PropTypes.string,
        artistSummary: PropTypes.string,
        artistName: PropTypes.string,
        artistSocialLinks: ARTIST_SOCIAL_LINKS_PROPTYPE,
    };

    render() {
        const {
            footerImage,
            footerSmallImage,
            artistImage,
            artistSummary,
            artistName,
            artistSocialLinks,
            experiments,
        } = this.props;

        let bucketClasses = 'content-bucket';

        if (!footerImage && !footerSmallImage) {
            bucketClasses = classNames(
                'eds-l-mar-top-10',
                'eds-l-mw-pad-top-10',
                'eds-l-ln-pad-top-10',
                'eds-l-lg-pad-top-10',
                'eds-l-lw-pad-top-10',
            );
        }

        return (
            <footer className={bucketClasses}>
                <ArtistAttribution
                    image={artistImage}
                    summary={artistSummary}
                    name={artistName}
                    socialLinks={artistSocialLinks}
                    experiments={experiments}
                />
                <FooterImage
                    footerImage={footerImage}
                    footerSmallImage={footerSmallImage}
                    experiments={experiments}
                />
            </footer>
        );
    }
}
